module.exports = __webpack_public_path__ + "img/upload-frontal-exotics.2f780e6d.jpg";